import React, { useEffect, useState } from "react";
import CreateClassModal from "./modals/CreateClassModal";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import { Dropdown } from "react-bootstrap";
import { GearFill, Plus, Calendar3 } from "react-bootstrap-icons";
import EditClassModal from "./modals/EditClassModal";
import DeleteClassModal from "./modals/DeleteClassModal";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useNavigate } from "react-router-dom";

export default function Classes({ pendingclub, reviewPendingClub, changeView }) {
  const [addClassModal, setAddClassModal] = useState(false);
  const [classes, setClasses] = useState([]);
  const navi = useNavigate();
  const [selectedClass, setSelectedClass] = useState(null);
  const [editClassModal, setEditClassModal] = useState(false);
  const [deleteClassModal, setDeleteClassModal] = useState(false);
  const [mondayClasses, setMondayClasses] = useState([]);
  const [tuesdayClasses, setTuesdayClasses] = useState([]);
  const [wednesdayClasses, setWednesdayClasses] = useState([]);
  const [thursdayClasses, setThursdayClasses] = useState([]);
  const [fridayClasses, setFridayClasses] = useState([]);
  const [saturdayClasses, setSaturdayClasses] = useState([]);
  const [sundayClasses, setSundayClasses] = useState([]);
  const { user, dispatch } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);

  const cancelModal = () => {
    setAddClassModal(false);
    setEditClassModal(false);
    setDeleteClassModal(false);
  };

  const groupClassesByDay = () => {
    const days = {
      Monday: [],
      Tuesday: [],
      Wednesday: [],
      Thursday: [],
      Friday: [],
      Saturday: [],
      Sunday: [],
    };
    classes.forEach((classItem) => {
      if (days[classItem.day]) days[classItem.day].push(classItem);
    });
    Object.keys(days).forEach((day) => {
      days[day].sort((a, b) => a.timeIn - b.timeIn);
    });
    setMondayClasses(days.Monday);
    setTuesdayClasses(days.Tuesday);
    setWednesdayClasses(days.Wednesday);
    setThursdayClasses(days.Thursday);
    setFridayClasses(days.Friday);
    setSaturdayClasses(days.Saturday);
    setSundayClasses(days.Sunday);
  };

  useEffect(() => {
    groupClassesByDay();
  }, [classes]);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const res = await axios.put(
        `${ApiConnectionString}/api/pendingClub/EnableEdit?ClassesSubmitted=true`,
        null,
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
      if (res.status === 200) reviewPendingClub();
    } catch (err) {
      if (err.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error in handleSubmit:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${ApiConnectionString}/api/PendingEvents`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      if (res.status === 200) setClasses(res.data);
    } catch (err) {
      console.error("Error fetching pending classes:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;
    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [user]);

  const renderDayColumn = (day, classList) => (
    <div className="col p-0">
      <div>
        <div className="timetable-wkday text-center rounded-top">
          <p className="px-5">{day}</p>
        </div>
        {classList.length === 0 ? (
          <div className="classes-container d-flex align-items-center justify-content-center text-center">
            <div>
              <Calendar3 size={32} className="mt-5 mb-2 text-muted" />
              <p className="text-muted my-4">No class added</p>
            </div>
          </div>
        ) : (
          classList.map((activity) => (
            <div className="classes-container" key={activity.id}>
              <Dropdown>
                <Dropdown.Toggle as="span" id="dropdown-custom-components" className="dropdown-toggle-custom">
                  <GearFill
                    className="m-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => setSelectedClass(activity)}
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setEditClassModal(true)}>Edit</Dropdown.Item>
                  <Dropdown.Item onClick={() => setDeleteClassModal(true)}>Delete</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div className="class-content text-center">
                <p className="fontSize20">{activity.name}</p>
                <p className="fontSize12">{activity.description}</p>
                <p className="fontSize14">Time in: {String(activity.timeIn).padStart(4, "0").replace(/(\d{2})(\d{2})/, "$1:$2")}</p>
                <p className="fontSize14">Time out: {String(activity.timeOut).padStart(4, "0").replace(/(\d{2})(\d{2})/, "$1:$2")}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );

  if (isLoading) return <LoadingSpinner />;

  return (
    <div>
                <button
        className="floating-back-button"
        onClick={() => changeView("clubImages")}
      >
        ← Back to Club Images
      </button>
      <div className="lightBlueBanner">
        <p className="fw-bold p-2">Classes</p>
      </div>

           <button
        className="profile-blue-button mb-2 d-flex"
        onClick={() => setAddClassModal(true)}
      >
        {" "}
        <Plus className="profile-social-icon" />
        <a className="fw-bold mx-2 mt-1">Add Class</a>
      </button>

      <div className="row timetable mx-5">
        {renderDayColumn("Monday", mondayClasses)}
        {renderDayColumn("Tuesday", tuesdayClasses)}
        {renderDayColumn("Wednesday", wednesdayClasses)}
        {renderDayColumn("Thursday", thursdayClasses)}
        {renderDayColumn("Friday", fridayClasses)}
        {renderDayColumn("Saturday", saturdayClasses)}
        {renderDayColumn("Sunday", sundayClasses)}
      </div>

      {!pendingclub.classesSubmitted ? (
        <button className="my-5 saveChanges-button" onClick={handleSubmit}>Submit</button>
      ) : (
        <><div className="d-flex justify-content-between my-5">
    <button className="pointer cancelButton fw-bold" onClick={() => changeView("clubImages")}>Go back</button>
          <button className="blue-button" onClick={() => changeView("paymentOptions")}>Continue</button>
        </div>
      
        </>
      )}

      {deleteClassModal && (
        <DeleteClassModal fetchData={fetchData} cancelModal={cancelModal} selectedClass={selectedClass} />
      )}
      {editClassModal && (
        <EditClassModal fetchData={fetchData} cancelModal={cancelModal} selectedClass={selectedClass} />
      )}
      {addClassModal && (
        <CreateClassModal fetchData={fetchData} cancelModal={cancelModal}  pendingclub={pendingclub}/>
      )}
    </div>
  );
}
